import { Math } from "core-js";
import moment from "moment";

export const getDifferenceInDays = (earlierDate, newerDate) => {
  return newerDate.diff(earlierDate, "days");
};

export const daysToWeeks = (days) => Math.floor(days / 7);
export const daysToMonths = (days) => Math.floor(days / 30);
export const daysToYears = (days) => Math.floor(days / 365);

export const formatDate = (date) => date ? moment(date).format("DD-MMM-YYYY HH:mm") : '-';